import { Button } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

export const SideBarButton = ({ icon, title, link }) => {
  const history = useHistory();

  return (
    <>
      <Button
        size="lg"
        isFullWidth
        pl={5}
        py={7}
        mt={2}
        border="none"
        variant="ghost"
        justifyContent="flex-start"
        leftIcon={icon}
        onClick={() => {
          history.push(link);
        }}
      >
        {title}
      </Button>
    </>
  );
};
